export default {
    company: {
        name: "Yibin Paper Industry Co., Ltd."
    },
    nav: {
        home: "Главная",
        about: "О компании",
        products: "Продукция",
        contact: "Контакты",
        sustainability: "Устойчивое развитие",
        technology: "Технические инновации"
    },
    banner: {
        title: "Бамбуковая мелодия · Зелёное будущее",
        subtitle: "Сохраняя тысячелетние традиции бумажного производства, задаём новые стандарты в производстве бамбуковой целлюлозы"
    },
    products: {
        subtitle: "Высококачественная бумага из бамбуковой целлюлозы для разнообразных потребностей",
        description: "Мы предлагаем комплексные решения в области бумажной продукции - от бумаги-основы до готовых изделий, удовлетворяя все ваши потребности",
        viewDetails: "Подробнее",
        categories: {
            title: "Линейка продукции",
            subtitle: "Бумажные изделия из бамбуковой целлюлозы, задающие тренд экологичного потребления",
            livingPaper: "Базисная бумага для бытовых товаров",
            livingPaperDesc: "Продукция из базисной бумаги для бытовых товаров",
            foodPaper: "Базисная бумага для пищевой упаковки",
            foodPaperDesc: "Продукция из базисной бумаги для пищевой упаковки",
            finishedProducts: "Линейка готовых бытовых бумажных изделий"
        },
        advantages: {
            title: "Преимущества продукции",
            subtitle: "Обновляем жизнь силой бамбука"
        },
        applications: {
            title: "Области применения",
            subtitle: "Широко применяется в повседневной жизни и различных отраслях"
        },
        cta: {
            title: "Нужны индивидуальные решения?",
            description: "Предлагаем профессиональные услуги по кастомизации бумажной продукции из бамбуковой целлюлозы под ваши требования",
            buttonText: "Свяжитесь с нами"
        },
        detail: {
            features: 'Характеристики продукции',
            contactUs: 'Свяжитесь с нами',
            specifications: 'Спецификации продукции',
            usageScenarios: 'Сценарии использования',
            relatedProducts: 'Сопутствующая продукция',
            cta: {
                title: 'Нужна дополнительная информация?',
                description: 'Наши консультанты всегда готовы предоставить профессиональную консультацию и индивидуальные решения',
                buttonText: 'Свяжитесь с нами'
            }
        },
        title: "Основная продукция"
    },
    advantages: {
        title: "Наши преимущества",
        subtitle: "Производство бумаги из бамбуковой целлюлозы: экологичные технологии, превосходное качество",
        items: {
            experience: {
                title: "Глубокий отраслевой опыт",
                description: "80-летний технологический опыт, полная производственная цепочка целлюлозно-бумажной промышленности, надежная техническая поддержка перехода на зеленые низкоуглеродные биоматериалы."
            },
            production: {
                title: "Зрелая система масштабируемого производства",
                description: "Полностью оборудованные производственные мощности и автоматизированные линии обеспечивают быструю реакцию на запросы клиентов и рентабельное массовое производство."
            },
            innovation: {
                title: "Инновационные разработки в сотрудничестве с наукой и образованием",
                description: "Совместные лаборатории с вузами и НИИ, фокус на разработке низкоуглеродных технологий и возобновляемых материалов, ускорение коммерциализации передовых технологий."
            },
            certification: {
                title: "Полная цепочка экологических сертификатов",
                description: "Сертификация FSC, медицинских и гигиенических продуктов на всех этапах - от закупки сырья до производства, повышающая конкурентоспособность продукции."
            }
        }
    },
    footer: {
        contact: "Свяжитесь с нами",
        address: "Адрес: Yibin Paper Industry, Peishi Light Industrial Park, Nanxi District, Yibin, Sichuan",
        phone: "Тел: 0831-3309663",
        email: "Email: ybzy@yb-zy.com",
        quickLinks: "Быстрые ссылки",
        moreInfo: "Дополнительная информация",
        news: "Новости",
        careers: "Карьера",
        informations: "Раскрытие информации",
        followUs: "Следите за нами",
        wechat: "WeChat: Yibin Paper Industry",
        rights: "Все права защищены",
        slogan: "Производство бумаги из бамбуковой целлюлозы: зеленые инновации",
        ICPfiling: "蜀ICP备05027078号-1",
        PublicSecurityFiling: "川公网安备51150302000130号"
    },
    about: {
        companyProfile: "О компании",
        established: "Основана в 1944 году",
        formerName: `Бывшая "Китайская бумажная фабрика"`,
        firstNewsprint: "Место производства первой отечественной газетной бумаги машинного производства",
        listed: "Вышла на Шанхайскую фондовую биржу в 1997 году (код: 600793)",
        firstListed: "Первая публичная компания в целлюлозно-бумажной промышленности Китая",
        firstYibinListed: "Первая публичная компания в Ибине",
        wuliangyeSubsidiary: "Дочерняя компания группы Wuliangye",
        firstNewMeterial: "Ведущее предприятие в цепочке производства инновационных бамбуковых материалов",
        capacity: "Производственные мощности",
        mainCapacity: "Головное предприятие: 540 000 тонн целлюлозы и бумаги в год",
        managedCapacity: "Управляемые предприятия: 120 000 тонн целлюлозы и бумаги в год",
        newMaterialCapacity: "Новые материалы: 100 млн м² гофрокартона в год",
        bambooMoldingCapacity: "Новые материалы: 6 600 тонн формованных изделий из бамбуковой целлюлозы в год",
        celluloseCapacity: "Ацетат целлюлозы: 30 000 тонн в год",
        historyTitle: "Вехи развития",
        historySubtitle: "70 лет упорной работы, создание бренда бамбуковой бумаги",
        historyItems: {
            "1944": "Основание Китайской бумажной фабрики, начало истории бумажной промышленности Китая",
            "1945": "Успешное производство первой 100% механической древесной массы для газетной бумаги",
            "1950": `Переименование в "Ибиньскую бумажную фабрику"`,
            "1961": "Визит председателя Чжу Дэ",
            "1966": "Визит маршала Пэн Дэхуая",
            "1988": `Пилотный проект акционирования, создание "Yibin Paper Industry Co., Ltd."`,
            "1997": "Листинг на Шанхайской фондовой бирже",
            "2012": "Закладка фундамента нового комплекса Yibin Paper Industry",
            "2015": "Запуск линии базисной бумаги для пищевой упаковки",
            "2018_1": "Запуск линии бытовой бумаги",
            "2018_2": "Становление дочерней компанией группы Wuliangye",
            "2025": "Стратегический переход от традиционного производства к созданию комплексной группы по производству зеленых биоматериалов"
        },
        futureDevelopment: "Будущее развитие",
        future: {
            point1: "Концентрация на целях развития",
            point2: "Максимальное использование преимуществ бамбуковых ресурсов",
            point3: "Ускоренный переход к специализированным высокотехнологичным продуктам с высокой добавленной стоимостью",
            point4: "Создание мирового лидера в нишевых сегментах бумажной продукции"
        },
        coreValues: "Корпоративная философия",
        coreValuesSubtitle: "Бамбук - основа, бумага - душа, зеленые инновации двигают развитие",
        values: {
            mission: "Миссия",
            missionLine1: "Основано на новых биоматериалах",
            missionLine2: "Создаем лучший мир с зеленым углеродным следом",
            vision: "Видение",
            visionLine1: "Стать комплексной группой",
            visionLine2: "по производству специальных зеленых биоматериалов",
            coreValues: "Ключевые ценности",
            coreValuesLine1: "Качество прежде всего, движимые инновациями",
            coreValuesLine2: "Зеленое развитие, совместное создание ценностей",
            philosophy: "Принципы управления",
            philosophyLine1: "Клиентоориентированность",
            philosophyLine2: "Качество - основа, инновации - движущая сила"
        },
        certificationsTitle: "Сертификаты",
        certificationsSubtitle: "Гарантия качества, признание отрасли",
        certificationItems: {
            fsc: "Международная лесная сертификация",
            fscDesc: "Сертификация ответственного лесопользования",
            iso9001: "Сертификат ISO9001",
            iso9001Desc: "Международный сертификат системы менеджмента качества",
            iso14001: "Сертификат FSSC22000",
            iso14001Desc: "Сертификат системы безопасности пищевых продуктов",
            medical: "Сертификация медицинской продукции",
            medicalDesc: "Сертификат медицинской продукции",
            antibacterial: "Антибактериальный сертификат",
            antibacterialDesc: "Сертификат антибактериальных свойств",
            safety: "Сертификация гигиенической безопасности",
            safetyDesc: "Сертификат гигиенической безопасности продукции"
        },
        honorsTitle: "Награды компании",
        honorsSubtitle: "Гарантия качества, признание отрасли",
        honorItems: {
            greenFactory: `Национальное звание "Зеленый завод"`,
            greenFactoryDesc: `Звание "Флагман зеленого производства" от MIIT Китая`,
            forestryLeader: "Ведущее предприятие лесного хозяйства национального значения",
            forestryLeaderDesc: "Звание ключевого лидера отрасли от Национального управления лесного и степного хозяйства",
            agriculturalProduct: "Лучшее предприятие агропромышленного комплекса Китая",
            agriculturalProductDesc: "Лучший бренд агропромышленного предприятия Китая",
            lightIndustry: "Передовое предприятие легкой промышленности",
            lightIndustryDesc: "Передовое предприятие легкой промышленности",
            bambooProduct: "Топ-10 производителей бамбуковой продукции",
            bambooProductDesc: "Топ-10 брендов бамбуковой индустрии Китая",
            engineeringCenter: "Инженерно-исследовательский центр целлюлозно-бумажной промышленности",
            engineeringCenterDesc: "Инженерно-исследовательский центр бамбуковой целлюлозы провинции Сычуань"
        },
        productHonorsTitle: "Награды продукции",
        productHonorsSubtitle: "Гарантия качества, признание отрасли",
        productHonorItems: {
            industryExcellence: "Продукция отраслевого мастерства",
            neZhaExcellence: `Серия "Нечжа" - продукт мастерства индустрии бытовой бумаги Китая 2025`,
            moDiKaExcellence: `Серия "Модика" - продукт мастерства индустрии бытовой бумаги Китая`,
            bambooExpoGold: "Золотая медаль Международной выставки бамбука",
            moDiKaGold: `Серия "Модика" - золотая медаль Международной выставки бамбука 2025`,
            shanghaiExpoGold: "Золотая медаль Международной выставки бамбука",
            jinZhuGold: `Серия "Золотой бамбук" - золотая медаль Шанхайской международной выставки бамбука 2020`,
            quanZhuGold: "Базисная упаковочная бумага из бамбука - золотая медаль Шанхайской международной выставки бамбука 2018",
            westernExpoGold: "Золотая медаль Западной китайской лесопромышленной выставки",
            jinZhuWesternGold: `Серия "Золотой бамбук" - золотая медаль Западной китайской лесопромышленной выставки`
        },
        cta: {
            title: "Присоединяйтесь к Yibin Paper Industry, создадим зеленое будущее вместе",
            description: "Ждем сотрудничества для совместного продвижения устойчивого развития индустрии бамбуковой бумаги",
            buttonText: "Свяжитесь с нами"
        }
    },
    technology: {
        title: 'Технологические инновации',
        subtitle: 'Технологии ведут, зеленые инновации создают новые стандарты в индустрии бамбуковой бумаги',
        innovation: {
            title: 'Инновации двигают развитие',
            subtitle: 'Технологии ведут, зеленые инновации создают новые стандарты в индустрии бамбуковой бумаги',
            management: {
                title: 'Эффективная координация инновационной системы управления',
                content: 'Yibin Paper Industry считает технологические инновации ключевым драйвером развития, создает Комитет по стратегии и развитию для координации R&D, производства и маркетинга'
            },
            team: {
                title: 'Профессиональные команды ведут технологические прорывы',
                content: 'Опираясь на провинциальные инновационные платформы и R&D команды, тесно сотрудничая с ведущими вузами и НИИ, фокусируясь на низкоуглеродной целлюлозе и биоматериалах, обеспечивая мощный импульс инновациям.'
            },
            results: {
                title: 'Инновации стимулируют модернизацию отрасли',
                content: 'Владение ключевыми технологиями полного цикла производства, прорывы в зеленой целлюлозе и чистых производствах, лидерство в переходе на зеленые биоматериалы.'
            }
        },
        core: {
            title: 'Ключевые технологии',
            subtitle: 'Технологии ведут, зеленые инновации',
            tabs: {
                pulping: 'Технологии производства бамбуковой целлюлозы',
                bleaching: 'Ключевые технологии циркулярной экономики',
                papermaking: 'Инновационные технологии зеленой продукции'
            },
            items: {
                pulping: {
                    details: [
                        {
                            title: 'Система предварительной обработки бамбука',
                            content: 'Решение проблем обработки высокой плотности и кремнезема в бамбуке, разработка технологии гомогенной пропитки, снижение энергопотребления >10%.'
                        },
                        {
                            title: 'Технологии низкоуглеродного производства целлюлозы',
                            content: '"Комбинированная технология "глубокая делигнификация + ECF-отбелка", выбросы AOX на 30% ниже госстандарта; интегрированная очистка "анаэробная+аэробная+Фентон", выбросы COD на 50% ниже нормы.'
                        }
                    ]
                },
                bleaching: {
                    details: [
                        {
                            title: 'Технология полной утилизации компонентов бамбука',
                            content: 'Целлюлоза - для бумаги; лигнин черного щелока - для генерации тепла (350 кВтч/тонна); отходы - в биоудобрения.'
                        }
                    ]
                },
                papermaking: {
                    details: [
                        {
                            title: 'Функциональные продукты из бамбукового волокна',
                            content: 'Технология усиления бамбуковым волокном: +50% к прочности упаковочной бумаги; самоантибактериальная бытовая бумага: +90% эффективности благодаря натуральным компонентам бамбука.'
                        },
                        {
                            title: 'Новые биоматериалы',
                            content: 'Продукты из бамбукового волокна заменяют пластик, сокращая углеродный след на 60%.'
                        }
                    ]
                }
            }
        },
        research: {
            title: 'R&D центр',
            subtitle: 'Сфокусированные исследования, создание ценностей',
            imageAlt: 'R&D центр Yibin Paper Industry',
            center: {
                title: 'Инновационная R&D платформа',
                content: 'Основан в 2003 г. как ключевое подразделение технологических инноваций. Провинциальный технический центр с двумя инновационными платформами. Инициатор "Сообщества интеграции образования и индустрии бамбука", участник госпроекта "Ключевые технологии интеграции бамбуковой целлюлозы и бумаги". Богатый опыт в ключевых технологиях производства.'
            },
            cooperation: {
                title: 'Совместные исследования',
                content: 'Долгосрочное сотрудничество с ведущими вузами и НИИ, совместная реализация национальных и провинциальных проектов, глубокая интеграция образования, науки и производства.'
            }
        },
        patents: {
            title: 'Патенты и достижения',
            subtitle: 'Технологические накопления, лидерство в отрасли',
            authorized: {
                title: 'Выданные патенты',
                items: [
                    'Способ получения очищенной смешанной бамбуковой массы и ее применение в бумажном производстве',
                    'Способ получения очищенной бамбуковой массы и ее применение в бумажном производстве',
                    'Форсунка черного щелока для печи регенерации щелочи',
                    'Устройство для отбора волокон'
                ]
            },
            projects: {
                title: 'Научные проекты',
                items: [
                    'Исследование чистого энергосберегающего производства объемной высокопрочной бамбуковой массы и технологии смешения для прочного упаковочного картона',
                    'Исследование очистки химической бамбуковой массы и технологии смешения для премиальной бытовой бумаги',
                    'Исследование и разработка технологий глубокой переработки бамбуковой массы',
                    'Исследование и разработка высококачественных целлюлозных волокон на основе бамбука',
                    'Исследование и разработка продуктов с высокой добавленной стоимостью на основе функционального лигнина'
                ]
            },
            awards: {
                title: 'Научные награды',
                items: [
                    'Первая премия за технологический прогресс провинции Сычуань'
                ]
            },
            papers: {
                title: 'Научные публикации',
                items: [
                    'Определение общего канифоли и сульфата алюминия в катионных диспергированных канифольных клеях',
                    'Разработка небеленой пищевой картонной бумаги с бамбуковой химико-механической массой',
                    'Применение варки с добавками для DDS-варки цельного бамбука',
                    'Новая технология эффективного использования бамбукового волокна в производстве растворимой массы через фракционирование: лабораторные и заводские испытания',
                    'Стратегия кавитационно-ультразвукового деполимеризации для высокоценного использования лигнина'
                ]
            }
        },
        projects: {
            title: 'Инновационные проекты',
            subtitle: 'Задаем направления будущего развития отрасли',
            items: [
                {
                    title: 'Интеграция ключевых технологий бамбуковой цепочки Сычуаня и демонстрационный завод',
                    period: '2019-2022',
                    cooperation: 'Сычуаньский сельскохозяйственный университет',
                    desc: 'Органичная интеграция ресурсной и производственной цепочек для развития бамбуковой индустрии.'
                },
                {
                    title: 'Создание и демонстрация высокотехнологичной инновационной платформы лесной и бамбуковой индустрии Ибиня',
                    period: '2019-2022',
                    cooperation: 'Южно-Китайский технологический университет',
                    desc: 'Прорыв в технологиях низкосернистой варки бамбука и высокоценного использования черного щелока.'
                },
                {
                    title: 'Исследование и разработка технологий глубокой переработки бамбуковой массы',
                    period: '2022-2024',
                    cooperation: 'Китайская академия лесных наук',
                    desc: 'Прорыв в ключевых технологиях высокоурожайной варки бамбука, промышленное внедрение, импортозамещение сырья.'
                },
                {
                    title: 'Исследование и разработка продуктов с высокой добавленной стоимостью на основе функционального лигнина',
                    period: '2022-2024',
                    cooperation: 'Пекинский лесной университет',
                    desc: 'Фракционное извлечение лигнина из черного щелока для побочных продуктов, прорыв в высокоценном использовании черного щелока.'
                },
                {
                    title: 'Исследование ключевых технологий интеграции бамбуковой целлюлозы и бумаги',
                    period: '2023-2028',
                    cooperation: 'Китайская академия лесных наук',
                    desc: 'Ключевые технологии: эффективная гомогенная пропитка, энергосберегающий помол точного разделения, активированная перекисно-щелочная отбелка.'
                },
                {
                    title: 'Исследование и демонстрация ключевых технологий интеллектуальной бамбуковой индустрии',
                    period: '2024-2027',
                    cooperation: 'Нанкинский лесной университет',
                    desc: 'Исследование ключевых проблем чистого производства и комплексного использования ресурсов на предприятиях по производству бамбуковой бумаги.'
                }
            ]
        },
        cta: {
            title: 'Совместное исследование будущего бамбуковой бумаги',
            subtitle: 'Приглашаем партнеров для совместного продвижения технологических инноваций в индустрии бамбуковой бумаги',
            button: 'Свяжитесь с нами'
        }
    },
    sustainability: {
        title: 'Устойчивое развитие',
        subtitle: 'Бамбук - основа, инновации - крылья. Создаём эталон зелёной низкоуглеродной биоматериальной индустрии.',
        vision: {
            title: 'Видение устойчивого развития',
            content: 'Бамбук - основа, инновации - крылья. Создаём эталон зелёной низкоуглеродной биоматериальной индустрии.',
            imageAlt: 'Видение устойчивого развития Yibin Paper',
            intro1: 'Как новатор в отрасли варки целлюлозы и производства бумаги из бамбука,',
            intro2: 'Yibin Paper фокусируется на "эффективном использовании бамбука + низкоуглеродные технологии", продвигая трансформацию традиционной отрасли в зелёную, высокоценную и циркулярную.',
            items: {
                circular: {
                    title: 'Зелёный низкий углерод, лидерство в циркулярной экономике',
                    content: 'Используя возобновляемость, быстрый рост и свойства секвестрации углерода бамбука, создаём полную цепочку "Ресурс бамбука -> Чистая варка целлюлозы -> Биоматериалы -> Низкоуглеродная продукция" с "нулевыми отходами, полным использованием", способствуя достижению целей "30/60" (углеродная нейтральность).'
                },
                innovation: {
                    title: 'Технологические инновации движут созданием высокой ценности',
                    content: 'Прорыв в высокоценном использовании бамбукового волокна. Разработка новых продуктов, заменяющих пластик (биоразлагаемая упаковка, биокомпозиты), снижение углеродного следа на протяжении всего ЖЦЦ.'
                },
                rural: {
                    title: 'Экологическая взаимовыгода, поддержка возрождения деревень',
                    content: 'Модель "Бамбуковые базы + Зелёные заводы + Симбиоз с сообществами" повышает доход от бамбуковых карбоновых кредитов, стимулирует развитие всей цепочки, объединяя экологические, экономические и социальные выгоды.'
                },
                cooperation: {
                    title: 'Открытое сотрудничество для совместного создания устойчивого будущего',
                    content: 'Объединение с НИИ и партнёрами по цепочке для разработки стандартов и продвижения технологий бамбуковых материалов, делая "Бамбук вместо пластика, Бамбук вместо дерева" глобальным зелёным решением.'
                }
            },
            commitment: {
                title: 'Наше обязательство:',
                content: 'Каждый стебель бамбука - симбиоз природы и технологий. Каждая инновация - для будущего Земли и человечества.'
            }
        },
        cleanProduction: {
            title: 'Чистое производство',
            subtitle: 'Защищаем чистые воды и зелёные горы инновационными технологиями, ведём устойчивое развитие чистым производством.',
            description: 'Как зелёный пионер отрасли, Yibin Paper придерживается принципа "Экология прежде всего, зелёное развитие". Чистые технологии, рециклинг ресурсов и низкоуглеродные инновации создают эффективную, чистую и устойчивую современную бумажную промышленность, предлагая глобальным клиентам зелёные решения.',
            items: {
                raw: {
                    title: 'Зелёное сырьё, низкоуглеродный источник',
                    subtitle: '100% устойчивое бамбуковое волокно, комплексное использование производственных отходов',
                    points: [
                        'Использование быстрорастущих бамбуковых ресурсов снижает вырубку лесов',
                        'Сильная способность бамбука к секвестрации углерода во время роста снижает выбросы с самого источника',
                        'Исследование путей комплексного использования отходов (бамбуковая стружка, белая грязь) для эффективного рециклинга ресурсов'
                    ]
                },
                process: {
                    title: 'Чистые технологии, энерго- и ресурсосбережение',
                    subtitle: 'Технологии варки целлюлозы с низким загрязнением, сверхнизкие выбросы сточных вод и газов',
                    points: [
                        'Применение передовых технологий (ECF-отбелка, кислородная делигнификация) значительно снижает выбросы AOX и др. вредных веществ.',
                        'Комбинация технологий (аэробная биологическая очистка и др.) обеспечивает сброс стоков в пределах нормы. Очищенная вода повторно используется для промывки сырья, снижая потребление свежей воды.',
                        'Оборудование (содорегенерационный котёл + электрофильтр + мокрая десульфуризация) гарантирует выбросы дымовых газов лучше госстандарта.'
                    ]
                },
                recycle: {
                    title: 'Циркулярная экономика: отходы в ресурсы',
                    subtitle: '100% рекуперация чёрного щёлока, утилизация шлама, повторное использование избыточного тепла',
                    points: [
                        'Сульфатные щёлока через систему регенерации соды преобразуются в тепло и химреагенты (самообеспеченность >85%), снижая зависимость от ископаемого топлива.',
                        'Бумажный шлам используется для производства органических удобрений или биотоплива, достигая "нулевого захоронения" твёрдых отходов.',
                        'Избыточное тепло производства используется для выработки электроэнергии, повышая энергоэффективность.'
                    ]
                },
                product: {
                    title: 'Зелёная продукция, низкоуглеродная жизнь',
                    subtitle: 'Биоразлагаемая упаковочная бумага, продукция с FSC-сертификацией',
                    points: [
                        'Пищевая упаковочная бумага из бамбукового волокна заменяет пластик, снижая "белое загрязнение".',
                        'Гарантия соответствия происхождения бумаги международным стандартам устойчивого лесопользования для высококлассного рынка.'
                    ]
                }
            }
        },
        circularEconomy: {
            title: 'Циркулярная экономика',
            subtitle: 'Бамбук используется полностью, жизнь бесконечна',
            imageAlt: 'Схема модели циркулярной экономики',
            intro: {
                title: 'Бамбук вместо дерева, зелёная энергия',
                content: 'Как сторонник эффективного использования бамбука, мы создали пятизвенную циркулярную модель "Бамбук - Целлюлоза - Бумага - Энергия - Удобрения", раскрывая зелёную энергию каждого стебля бамбука.'
            },
            items: {
                source: {
                    title: 'Зелёное начало: устойчивые бамбуковые ресурсы',
                    points: [
                        'Созданы модельные эко-бамбуковые базы с ротационной системой рубок.',
                        'Бамбук быстро растёт (3-5 лет до зрелости), секвестрирует углерод в 1.5 раза лучше китайской ели.',
                        'Повышение доходов 100 тыс. фермеров, преобразуя "Зелёные воды и горы" в "Золотые и серебряные горы".'
                    ]
                },
                core: {
                    title: 'Ключевой цикл: нулевые выбросы "трех отходов"',
                    points: [
                        'Жидкие отходы → Энергия: 100% рекуперация чёрного щёлока, генерация 60 млн кВт·ч/год.',
                        'Газообразные отходы → Ресурс: утилизация тепла дымовых газов котлов, снижение выбросов CO2.',
                        'Твёрдые отходы → Углеродный источник: бамбуковая стружка в биотопливные гранулы.'
                    ]
                },
                upgrade: {
                    title: 'Апгрейд продукции: полное использование бамбука',
                    points: [
                        'Пищевая упаковка и бумага для СГН из высококачественной бамбуковой массы (FSC).',
                        'Биоразлагаемые упаковочные материалы из бамбукового волокна (замена пластика).',
                        'Из бамбуковой стружки и жмыха производятся биотопливные гранулы.'
                    ]
                }
            },
            vision: {
                title: 'Наше видение:',
                content: 'Каждый стебель бамбука завершает зелёное путешествие от карбонового кредита до продукта.'
            }
        },
        socialResponsibility: {
            title: 'Социальная ответственность',
            subtitle: 'Тихое орошение, добрые дела по всему миру',
            tabs: {
                community: 'Развитие сообществ',
                farmers: 'Поддержка доходов фермеров',
                education: 'Развитие талантов',
                biodiversity: 'Экологичность'
            },
            community: {
                title: 'Программа возрождения деревень',
                description: 'Активно поддерживая госстратегию возрождения деревень, Yibin Paper через модель "Предприятие + Кооператив + Фермеры" развивает бамбуковую индустрию в окрестных деревнях, повышая их экономическую активность.',
                items: {
                    village: {
                        title: 'Помощь на местах в деревнях',
                        content: 'Компания направила 2 партработников как первых секретарей партячеек в дер. Шицзы (Юнсин, Цуйпин) и 1 партработника как члена рабочей группы в дер. Синван (Янчунь, Цзянъань).'
                    },
                    manager: {
                        title: 'Профессиональные менеджеры для коллективной экономики',
                        content1: 'Направлено 2 ключевых специалиста как "профессиональных менеджеров" в деревни для контроля деревенских финансов, нормативного регулирования, рыночной экспансии, маркетинга продукции, обучения предпринимателей, помогая повысить стандартизацию, рыночную ориентацию и профессионализм коллективной экономики.',
                    },
                    project: {
                        title: 'Проект "один-на-один" взаимовыгодного сотрудничества по развитию индустрии в дер. Дахэ Мяо (Синвэнь)',
                        content: 'Согласно схеме работы "один-на-один" г. Ибиня, компания сотрудничает с дер. Дахэ Мяо уезда Синвэнь для решения проблем со сбытом бамбукового сырья.'
                    }
                }
            },
            farmers: {
                title: 'Проект повышения доходов фермеров',
                description: 'Установлены стабильные связи с местными бамбуководами. Прямые закупки, инвестиции в умное оборудование, продвижение научной селекции и др. меры помогают увеличить доходы и достичь общего процветания.',
                imageAlt: 'Проект повышения доходов фермеров',
                items: {
                    direct: {
                        title: 'Прямые закупки под контролем: устранение посредников, защита интересов бамбуководов',
                        content1: 'Разрушена традиционная модель закупок. Созданы модели прямых закупок: "Предприятие + Склад спецкооператива + Фермеры", "Предприятие + Собственный склад + Фермеры" и др.',
                        content2: 'Укрепление сотрудничества между 1-м и 2-м секторами, устранение посредников, оптимизация затрат на всех этапах. Гарантия поставок сырья, удобство продаж для бамбуководов, стабильные цены, защита их интересов.'
                    },
                    tech: {
                        title: 'Технологии модернизируют отрасль, повышая доходы бамбуководов',
                        content1: 'Увеличение инвестиций в умное оборудование для рубки и транспортировки бамбука.',
                        content2: 'Повышение эффективности рубки и транспортировки, освобождение рабочей силы, снижение затрат, совместное использование технологических выгод с бамбуководами, рост их доходов.',
                        content3: 'Демонстрация научной селекции, посадки и ухода для повышения урожайности бамбуковых рощ.',
                        content4: 'Руководство научным выращиванием бамбука для снижения затрат, повышения урожайности с му и увеличения прибыли бамбуководов.'
                    },
                    value: {
                        title: 'Совместное создание ценности расширяет каналы, повышая совокупный доход',
                        content1: 'Активное исследование новых моделей сотрудничества для активации "нематериальных доходов" бамбуковых рощ. Пилотные проекты торговли бамбуковыми карбоновыми кредитами с третьими сторонами: фермеры получают дополнительные дивиденды за эффективный уход."',
                        content2: 'Одновременно стимулируется агролесоводство для повышения общей доходности. Сочетание агролесоводства и управления углеродными кредитами усиливает секвестрацию углерода, увеличивает доходы фермеров, создавая "экологический + экономический" выигрыш.'
                    }
                }
            },
            education: {
                title: 'Программа развития талантов для бамбуковой отрасли',
                description: 'Таланты - ключевой двигатель развития. Мы ценим их подготовку, создавая механизмы для развития будущих кадров отрасли.',
                imageAlt: 'Проекты развития талантов',
                items: {
                    mechanism: {
                        title: 'Механизмы развития талантов',
                        content: 'Механизмы "Наставник-ученик", резерв талантов, ротация, индивидуальные тренинги помогают сотрудникам пройти путь от новичков до элиты отрасли.'
                    },
                    path: {
                        title: 'Совершенствование карьерного роста',
                        content: 'Постоянное совершенствование карьерных путей и возможностей позволяет каждому раскрыть ценность в своей сфере и расти вместе с компанией.'
                    }
                }
            },
            biodiversity: {
                title: 'Программа "Зелёный завод"',
                description: 'Активно поддерживая национальные цели "Два углерода", мы фокусируемся на устойчивости, оптимизируя систему экологического менеджмента.',
                imageAlt: 'Экологические проекты',
                items: {
                    policy: {
                        title: '"Бамбук вместо дерева", "Бамбук вместо пластика"',
                        content: 'Активный отклик на политику "Бамбук вместо дерева/пластика" снижает воздействие на природу, способствует переходу к низкоуглеродной экономике, создавая экономические и экологические выгоды.'
                    },
                    factory: {
                        title: 'Зелёный завод',
                        content: 'Сертифицирован FSC FM/CoC, удостоен национального звания "Зелёный завод", звания "Чистое производство" пров. Сычуань. Продукция получила "Приз за выдающиеся энергосберегающие и экологичные продукты пров. Сычуань".'
                    }
                }
            }
        },
        report: {
            title: 'Отчёты об устойчивом развитии',
            subtitle: 'Прозрачное, достоверное и всестороннее раскрытие информации об устойчивом развитии',
            download: 'Скачать отчёт',
            items: {
                '2024': {
                    title: 'Отчёт об устойчивом развитии за 2024 год',
                    date: 'Дата публикации: Апрель 2024 г.',
                    imageAlt: 'Отчёт об устойчивом развитии за 2024 год'
                },
                '2023': {
                    title: 'Отчёт об устойчивом развитии за 2023 год',
                    date: 'Дата публикации: Апрель 2023 г.',
                    imageAlt: 'Отчёт об устойчивом развитии за 2023 год'
                }
            }
        },
        cta: {
            title: 'Создадим устойчивое будущее вместе!',
            description: 'Узнайте больше о практике устойчивого развития Yibin Paper или сотрудничайте с нами в продвижении зелёного развития.',
            buttonText: 'Свяжитесь с нами'
        }
    },
    home: {
        advantages: {
            title: "Наши преимущества",
            subtitle: "Производство бумаги из бамбуковой целлюлозы: экологичные технологии, превосходное качество",
            items: {
                experience: {
                    title: "Глубокий отраслевой опыт",
                    description: "80-летний технологический опыт, полная производственная цепочка целлюлозно-бумажной промышленности, надежная техническая поддержка перехода на зеленые низкоуглеродные биоматериалы."
                },
                production: {
                    title: "Зрелая система масштабируемого производства",
                    description: "Полностью оборудованные производственные мощности и автоматизированные линии обеспечивают быструю реакцию на запросы клиентов и рентабельное массовое производство."
                },
                innovation: {
                    title: "Инновационные разработки в сотрудничестве с наукой и образованием",
                    description: "Совместные лаборатории с вузами и НИИ, фокус на разработке низкоуглеродных технологий и возобновляемых материалов, ускорение коммерциализации передовых технологий."
                },
                certification: {
                    title: "Полная цепочка экологических сертификатов",
                    description: "Сертификация FSC, медицинских и гигиенических продуктов на всех этапах - от закупки сырья до производства, повышающая конкурентоспособность продукции."
                }
            }
        },
        products: {
            title: "Основная продукция",
            subtitle: "Высококачественная бумага из бамбуковой целлюлозы для разнообразных потребностей",
            items: {
                bambooPulp: {
                    title: "Первичная бамбуковая масса",
                    description: "Отборные виды бамбука, высококачественное бамбуковое волокно",
                    alt: "Бамбуковая масса"
                },
                packagingPaper: {
                    title: "Упаковочная бумага из первичной бамбуковой массы",
                    description: "Хорошая прочность, высокая устойчивость к излому, высокая чистота",
                    alt: "Упаковочная бумага"
                },
                culturalPaper: {
                    title: "Культурная бумага из первичной бамбуковой массы",
                    description: "Гладкая и тонкая, отличные ощущения при письме и печати",
                    alt: "Культурная бумага"
                },
                livingPaper: {
                    title: "Основа бумаги для СГН из первичной бамбуковой массы",
                    description: "Прочная во влажном состоянии, экологичная",
                    alt: "Основа бумаги для СГН"
                },
                finishedPaper: {
                    title: "Готовая бумага для СГН из первичной бамбуковой массы",
                    description: "Мягкая и прочная, здоровая и антибактериальная",
                    alt: "Готовая бумага для СГН"
                },
                fiberMaterial: {
                    title: "Волокнистые материалы",
                    description: "Многофункциональные, подходят для различных специальных нужд",
                    alt: "Волокнистые материалы"
                },
                learnMore: "Узнать больше"
            }
        },
        about: {
            title: "О Yibin Paper",
            description1: "Yibin Paper Co., Ltd., основанная в 1944 г., - ведущий китайский производитель бумаги из бамбуковой массы, специализирующийся на исследованиях и производстве.",
            description2: "Расположена в г. Ибинь, пров. Сычуань. Имеет богатые бамбуковые ресурсы и современное оборудование. Производственная мощность >500 тыс. тонн высококачественной бумаги из бамбуковой массы в год.",
            description3: "Стремимся предоставлять качественную и экологичную бумажную продукцию через инновации и зелёное производство, продвигая устойчивое развитие отрасли.",
            learnMore: "Узнать больше"
        },
        sustainability: {
            title: "Устойчивое развитие",
            subtitle: "Бумага из бамбуковой массы: зелёный цикл",
            items: {
                renewable: {
                    title: "Бамбук - возобновляемый ресурс",
                    description: "Бамбук созревает за 3-5 лет, быстро растёт - идеальное возобновляемое сырьё."
                },
                carbon: {
                    title: "Вклад в карбоновые кредиты",
                    description: "Бамбуковые рощи поглощают больше CO₂, чем лес на той же площади, эффективно замедляя изменение климата."
                },
                clean: {
                    title: "Чистое производство",
                    description: "Закрытый цикл производства, очистка и повторное использование сточных вод обеспечивают энергосбережение и снижение выбросов."
                },
                rural: {
                    title: "Возрождение деревень",
                    description: "Повышение доходов бамбуководов, стимулирование местной экономики, экологическая и экономическая выгода."
                }
            }
        },
        cta: {
            title: "Сотрудничайте с нами для создания зелёного будущего",
            description: "Мы стремимся предоставить качественную бумажную продукцию из бамбуковой массы и профессиональные услуги.",
            buttonText: "Свяжитесь с нами"
        }
    },
    contact: {
        banner: {
            title: 'Свяжитесь с нами',
            subtitle: 'Ваши запросы и отзывы всегда приветствуются.'
        },
        contactInfo: {
            title: 'Контакты',
            subtitle: 'Ваши запросы и отзывы всегда приветствуются.',
            address: {
                title: 'Адрес компании',
                content: 'Китай, пров. Сычуань, г. Ибинь, р-н Наньси, лёгкая промзона Пэйши',
                postcode: 'Почтовый индекс: 644100'
            },
            phone: {
                title: 'Телефон',
                main: 'Тел:0831-3309663',
                service: 'Горячая линия: 0831-3309698'
            },
            email: {
                title: 'Электронная почта',
                service: 'Обслуживание клиентов: ybzy@yb-zy.com',
                inquiry: 'Консультации по продукции: ybzy@yb-zy.com'
            },
            workingHours: {
                title: 'Часы работы',
                weekday: 'Пн-Пт: 9:00 - 17:30',
                holiday: 'Выходные в государственные праздники'
            }
        },
        inquiry: {
            title: 'Онлайн-консультация',
            subtitle: 'Заполните форму ниже, мы свяжемся с вами в ближайшее время',
            form: {
                name: 'Ваше имя',
                company: 'Название компании',
                email: 'Электронная почта',
                phone: 'Контактный телефон',
                subject: 'Тема запроса',
                subjectPlaceholder: 'Выберите тему запроса',
                subjects: {
                    product: 'Консультация по продукции',
                    price: 'Запрос предложения (КП)',
                    technical: 'Техническая поддержка',
                    cooperation: 'Обсуждение сотрудничества',
                    other: 'Другие вопросы'
                },
                message: 'Содержание запроса',
                submit: 'Отправить',
                submitting: 'Отправка...'
            },
            sales: {
                title: 'Отдел продаж',
                domesticRawPaper: 'Отдел внутр. продаж (Основа бумаги)',
                domesticFinishedPaper: 'Отдел внутр. продаж (Готовая бумага)',
                international: 'Международный отдел продаж',
                email: 'Email отдела продаж'
            },
            afterSales: {
                title: 'Послепродажное обслуживание',
                hotlineRawPaper: 'Горячая линия (Основа бумаги)',
                hotlineFinishedPaper: 'Горячая линия (Готовая бумага)',
                email: 'Email обслуживания'
            },
            social: {
                title: 'Подпишитесь на нас',
                wechat: 'Официальный WeChat',
                weibo: 'Официальный Weibo',
                linkedin: 'LinkedIn'
            }
        },
        location: {
            title: 'Расположение компании',
            subtitle: 'Добро пожаловать с визитом!',
            mapAlt: 'Расположение Yibin Paper Co., Ltd. на карте',
            transport: {
                public: {
                    title: 'Общественный транспорт',
                    content: 'Автобус: маршрут №10 [Чжунба] (Наньси) до ост. "Yibin Paper"'
                },
                driving: {
                    title: 'На автомобиле',
                    content: 'Навигация до "Yibin Paper Co., Ltd." (есть гостевой паркинг)'
                },
                airport: {
                    title: 'Трансфер из аэропорта',
                    content: 'Аэропорт Ибиня Wuliangye (58 км): трансфер или такси.'
                }
            }
        },
        offices: {
            title: '全球办事处',
            subtitle: '国际化服务网络',
            china: {
                title: '中国总部',
                flagAlt: '中国国旗',
                address: '四川省宜宾市翠屏区岷江西路159号',
                phone: '电话：0831-12345678'
            },
            usa: {
                title: '北美代表处',
                flagAlt: '美国国旗',
                address: '美国加利福尼亚州洛杉矶市橡树大道2588号',
                phone: '电话：+1-213-888-9999'
            },
            japan: {
                title: '日本代表处',
                flagAlt: '日本国旗',
                address: '日本东京都千代田区丸之内1-2-3',
                phone: '电话：+81-3-1234-5678'
            },
            europe: {
                title: '欧洲代表处',
                flagAlt: '德国国旗',
                address: '德国汉堡市汉萨街456号',
                phone: '电话：+49-40-8765-4321'
            },
            singapore: {
                title: '东南亚代表处',
                flagAlt: '新加坡国旗',
                address: '新加坡莱佛士码头10号',
                phone: '电话：+65-6789-0123'
            }
        },
        faq: {
            title: 'Часто задаваемые вопросы (ЧАВ)',
            subtitle: 'Быстрые ответы на ваши вопросы'
        },
        cta: {
            title: 'Ждём вашего обращения',
            description: 'Независимо от вашего вопроса или потребности, мы к вашим услугам.',
            buttonText: 'Немедленная консультация'
        }
    }
} 